<template>
	<div
		v-if="current && selected"
		class="header md-elevation-5"
		:style="{ borderBottom: '3px solid ' + modules_attr[selected.name] }"
		:class="selected.name + '-bar'"
	>
		<div style="display: flex; width: 100%">
			<div id="a1" style="margin-left: 0; margin-right: auto; display: flex; width: 80%">
				<div id="a2" class="container-header" v-if="loaded && approved">
					<md-button
						class="button md-elevation-4"
						:style="{ backgroundColor: selected.name == 'home' ? '#81c784' : '' }"
						v-bind:class="selected.name == 'home' ? ' rounded' : 'md-icon-button md-round'"
						@click="
							() => {
								$module = { path: '/home', name: 'home' }
								goTo({ path: '/home', name: 'home' })
							}
						"
					>
						<md-icon :style="{ color: selected.name == 'home' ? 'white' : '' }">home</md-icon>
						<div v-if="selected.name == 'home'">
							<span class="button-text">{{ $t(selected.name) }}</span>
						</div>
					</md-button>
					<div style="display: flex">
						<div v-for="item in organizationModules" :key="item.module.id">
							<div
								v-if="
									item.canView &&
									item.active &&
									(item.module.name == 'settings' || user.organization.confirmed)
								"
							>
								<el-tooltip placement="top" :open-delay="800">
									<div slot="content" style="display: flex">
										<div style="margin: auto">
											<div v-if="isExpired(item)" class="status-module expired" />
											<div v-else class="status-module enable" />
										</div>
										<span style="margin-left: 5px">{{ $t(item.module.name) }}</span>
										<span v-if="isExpired(item)" style="font-style: italic">
											{{ ": " + $t("expired") }}
										</span>
									</div>
									<md-button
										class="button md-elevation-4"
										:style="{
											backgroundColor: selected.name == item.module.name ? item.module.colour : ''
										}"
										v-bind:class="
											selected.name == item.module.name ? ' rounded' : 'md-icon-button md-round'
										"
										@click="changeModule(item)"
									>
										<svg
											v-if="isExpired(item)"
											height="25"
											width="25"
											style="position: absolute; top: 0; left: 0"
										>
											<line
												x1="0"
												y1="0"
												x2="25"
												y2="25"
												style="stroke: rgb(255, 0, 0); stroke-width: 2"
											/>
										</svg>
										<div>
											<md-icon
												:style="{ color: selected.name == item.module.name ? 'white' : '' }"
											>
												{{ item.module.icon }}
											</md-icon>
											<div v-if="selected.name == item.module.name">
												<span class="button-text">{{ $t(selected.name) }}</span>
											</div>
										</div>
									</md-button>
								</el-tooltip>
							</div>
						</div>

						<el-alert
							v-if="!mySubscription && !isSuperAdmin"
							:title="$t('expired-subscription')"
							type="warning"
							effect="dark"
							:closable="false"
							show-icon
						>
						</el-alert>
					</div>
				</div>
				<!--<div v-if="showRightScrollButton" style="padding-top: 10px; padding-bottom: 10px">
					<div class="scroll-button" @click="scrollLeft">
						<md-icon>keyboard_arrow_right</md-icon>
					</div>
				</div>
				<div style="padding-top:10px;padding-bottom:10px">
					<md-button v-if="hasPermissionTo(user.permissions, 'manage_organization_modules', user.roles)"
										 class="button md-icon-button " @click="addModule">
						<md-icon>add</md-icon>
					</md-button>
				</div>
				-->
			</div>

			<!-- <globalsearch style="margin-top: auto; margin-bottom: auto"></globalsearch> -->

			<notifications></notifications>
			<div class="user-menu">
				<el-popover style="margin-top: auto; margin-bottom: auto" placement="bottom" trigger="click">
					<div>
						<div>
							<span>{{ username }}</span>
						</div>
						<md-divider style="margin: 5px"></md-divider>
						<div class="menu-item" @click="goTo({ path: '/home', name: 'home' })">
							<i class="el-icon-s-home" />
							<span>{{ $t("dashboard") }}</span>
						</div>
						<div
							class="menu-item"
							v-if="user.organization.enterprize"
							@click="goTo({ path: '/component', name: 'organization' })"
						>
							<span>{{ $t("your-organization") }}</span>
						</div>
						<md-divider style="margin: 5px"></md-divider>
						<div class="menu-item" v-if="user.organization.confirmed" @click="goTo({ path: '/settings' })">
							<i class="el-icon-s-tools" />
							<span>{{ $t("settings") }}</span>
						</div>
						<div class="menu-item" @click="logout">
							<i class="el-icon-s-flag" />
							<span>{{ $t("logout") }}</span>
						</div>
					</div>
					<div slot="reference">
						<md-button class="md-icon-button md-elevation-4" md-menu-trigger>
							<md-avatar class="md-avatar-icon md-primary">
								<i class="el-icon-user pointer" style="color: white"></i>
							</md-avatar>
						</md-button>
					</div>
				</el-popover>
			</div>
		</div>
	</div>
</template>

<script>
import { hasPermissionTo, goto } from "@/utils/utils"
import { mapActions, mapGetters } from "vuex"
import moment from "moment"
import Notifications from "@/view/layout/layout-components/Notifications"
// import Globalsearch from "@/modules/globalsearch/globalsearch"

export default {
	name: "app-header",
	components: { Notifications },
	// components: { Globalsearch },
	data() {
		return {
			modules_attr: {},
			current: undefined,
			showRightScrollButton: false,
			showLeftScrollButton: false,
			selected_module: undefined,
			loaded: false,
			module_permissions: {}
		}
	},
	computed: {
		...mapGetters({
			user: "user/user",
			approved: "user/approved",
			roles: "user/roles",
			username: "user/username",
			modules: "user/modules",
			organizationModules: "organization/modules",
			isSuperAdmin: "user/isSuperAdmin",
			subscriptions: "organization/subscriptions",
			notifications: "user/notifications",
			active_subscription: "organization/active_subscription",
			mySubscription: "organization/active_subscription"
		}),

		selected: {
			get: function () {
				var route = this.$route.name
				if (this.$route.name) route = { name: this.$route.name.split(".")[0] }
				return route
			},
			set: function (newValue) {
				this.current = newValue
			}
		}
	},

	watch: {
		$route: function () {
			this.setHeader()
		},
		loaded: function () {},
		roles: function () {
			if (this.roles.length == 0) return
			this.controlModules()
			this.setHeader()
		},
		organizationModules: function () {
			this.controlModules()
			this.setHeader()
		}
		// active_subscription: function () {
		// 	if (this.isSuperAdmin) return
		// 	if (this.active_subscription) {
		// 		var diff = moment(this.active_subscription.valid_until).diff(moment(new Date()), "months", true)
		// 		if (diff < 1)
		// 			this.addNotifications({
		// 				title: this.$t("subscription"),
		// 				description: this.$t("subscription-expire-on").replace(
		// 					"%DATE%",
		// 					moment(this.active_subscription.valid_until).format("DD-MM-YYYY")
		// 				),
		// 				type: "warning",
		// 				code: 2
		// 			})
		// 	} else {
		// 		this.addNotifications({
		// 			title: this.$t("subscription"),
		// 			description: this.$t("none-subscriptions"),
		// 			type: "error",
		// 			code: 2
		// 		})
		// 	}
		// }
	},

	async created() {
		if (this.organizationModules.length == 0) await this.doOrganizationModules()
		this.controlModules()
		this.setHeader()
	},

	updated() {
		var a2 = document.getElementById("a2")
		if (a2 != null && a2.scrollLeft > 0) this.showLeftScrollButton = true
	},

	methods: {
		...mapActions({
			doLogout: "user/doLogout",
			doOrganizationModules: "organization/doModules",
			addNotifications: "user/addNotifications"
		}),
		hasPermissionTo,
		goto,
		/**
		 * routes
		 * */
		goTo: function (item) {
			const path = item.path || `/${item.name}`
			this.module = item
			this.goto(path)
		},
		addModule: function () {
			var path = "/router-modules"
			var name = "chooseModule"
			this.goTo({ path, name })
		},
		dashboard: function () {
			this.goTo({ name: "home", path: "/home" })
		},
		profile: function () {
			this.goTo("/profile")
		},
		settings: function () {
			this.goTo("/setting")
		},
		logout: function () {
			this.doLogout()
		},
		/**
		 * scrolling header buttons
		 */
		scrollLeft: function () {
			var a2 = document.getElementById("a2")
			a2.scrollLeft += 50

			if (!this.showLeftScrollButton) {
				this.showLeftScrollButton = true
			} else {
				if (a2.scrollLeft <= 50) this.showLeftScrollButton = false
			}
			if (a2.offsetWidth + a2.scrollLeft + 50 > a2.scrollWidth) {
				this.showRightScrollButton = false
			}
		},
		scrollRight: function () {
			var a2 = document.getElementById("a2")
			a2.scrollLeft -= 50
			if (a2.offsetWidth + a2.scrollLeft < a2.scrollWidth) this.showLeftScrollButton = false
			if (a2.scrollLeft > 50) this.showRightScrollButton = true
		},
		/**
		 * setting header
		 */
		setHeader: function () {
			var path = this.$route.path
			var name = this.$route.name

			if (name) {
				var split = name.split("-")
				name = split.length > 1 ? split[1] : split[0]
			}
			if (name == null) name = "home"

			this.current = { path, name }
			this.selected = { path, name }
			for (var item of this.organizationModules) {
				if (this.selected && item.module && this.selected.name == item.module.name) this.$module = item.module
				if (!this.modules_attr[item.module.name]) {
					this.modules_attr[item.module.name] = item.module.colour
				}
			}
		},
		/**
		 * check which module can be seen, and if expired or not
		 */
		controlModules: function () {
			this.organizationModules.forEach(module => {
				var can = false
				//check if user has administrator role
				for (let role of this.user.roles) {
					if (role.name == "administrator" || role.name == "full-administrator") {
						can = true
						break
					}
				}
				//if user hasn't got a administrator role, check his permissions
				if (!can)
					for (let permission of this.user.permissions) {
						if (permission.module.name == module.module.name) {
							can = true
							break
						}
					}
				module.canView = can
			})
			this.loaded = true
		},

		isExpired: function (module) {
			var result = false
			if (module.expiration == null) result = false
			else result = new Date(module.expiration) < new Date()
			return result
		},

		changeModule(item) {
			this.$module = item
			if (item.expiration == undefined || new Date(item.expiration) > new Date()) this.goTo(item.module)
			else this.goTo({ path: "/home", name: "home" })
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-menu";

.container-header {
	display: flex;
	padding-top: 10px;
	padding-bottom: 10px;
	scroll-behavior: smooth;
	overflow-x: auto;
	border-radius: 25px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;

	&::-webkit-scrollbar {
		height: 0px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background: #888;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
}

.header {
	background-color: white;
	width: 100%;

	font-size: 12px;
	overflow-x: hidden;
}

.pointer {
	cursor: pointer;
}

.md-menu-content {
	margin-top: 40px;
}

.md-menu-item {
	cursor: pointer;
	border-left: 3px solid transparent;
}

.md-menu-item:hover {
	background-color: #9c27b0;

	span {
		color: white;
	}
}

.selected {
	border-left: 3px solid #9c27b0;
	border-radius: 5px 0px 0px 5px;
	background-color: rgba(155, 39, 175, 0.3);
}

.button {
	margin-left: 8px;
	margin-right: 8px;
	margin-top: auto;
	margin-bottom: auto;
}

.module {
	width: 40px;
	height: 40px;
	border-radius: 30px;
	display: flex;

	:hover {
		cursor: pointer;
	}
}

.button-text {
	font-size: 10px;
	color: white;
}

.rounded {
	border-radius: 25px;
	height: 40px;
}

.status-module {
	padding: 5px;
	border-radius: 10px;
}

.enable {
	background-color: limegreen;
}

.disabled {
	background-color: #ffa726;
}

.expired {
	background-color: red;
}

.user-menu {
	padding-top: 10px;
	padding-bottom: 10px;
}

.scroll-button {
	margin-top: 2px;
	margin-bottom: 2px;
	padding: 5px;
	border-radius: 25px;

	&:hover {
		background-color: rgba(0, 0, 0, 0.1);
		cursor: pointer;
	}
}

.menu-item:hover {
	background-color: purple;
}
</style>
